import useSWR from "swr";

import { CatCard } from "../components/KbCards";
import { api } from "../services/api";

/** Every KB topic, as a category grid. */
export function KbCategories() {
  const { data: categories } = useSWR<string[]>("/api/kb/categories", () => api.kb.categories());
  return (
    <div className="kb-page">
      <div className="page-header">
        <h1 className="page-title">Categories</h1>
        <p className="page-subtitle">
          Every topic in the knowledge base. Pick one to see its articles and guides.
        </p>
      </div>
      <div className="kb-cat-grid">
        {(categories ?? []).map((c) => (
          <CatCard key={c} category={c} />
        ))}
      </div>
    </div>
  );
}

export default KbCategories;
